






















































































/* eslint-disable prettier/prettier */
import Vue from 'vue'

import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { INCLUDE_VITALS_PROGRAM, PATIENT_NOUN } from '@/constants/app-variables'

import { UserActionContexts } from '@/constants/urls'

import SiteStatsGlucometerDataTable from '@/components/site-stats/SiteStatsGlucometerDataTable.vue'
import SiteStatsVitalsDataTable from '@/components/site-stats/SiteStatsVitalsDataTable.vue'
import SiteStatsFilterFunctions from '@/components/site-stats/SiteStatsFilterFunctions.vue'
import { AppGetterNames } from '@/store/modules/app/keys'
import { FlatSite } from '@/store/modules/site/getters'
import {
  ActionNames as SiteStatsActionNames,
  GetterNames as SiteStatsGetterNames,
} from '@/store/modules/site-stats/keys'
import { ActionNames } from '@/store/modules/patient-with-detailed-reports/keys'
import { OFFSET_HOURS_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
import moment from 'moment-timezone'
import {
  calcTotalEmrCost,
  calcStripRevenue,
  calcOneTimeVitalSignGatewayRevenue,
  getOneTimeVitalsGatewayCost,
  calcMonthlyRevenueTotal,
  getOneTimeGlucometerGatewayCost,
  getSelectedYearMonthsArray,
} from '@/constants/site-stats'
import { toCurrency } from '@/store/utils/converter'
import SiteStatsLiveStatusDataTable from '@/components/site-stats/SiteStatsLiveStatusDataTable.vue'
import { AGT_DEBUG } from '@/utils/constants'
import SiteStatsCashFlowDataTable from '@/components/site-stats/SiteStatsCashFlowDataTable.vue'
import CashFlowSummary from '@/components/site-stats/CashFlowSummary.vue'
import { MIN_TIMESTAMP } from '@/constants/cash-flow'
const filterOptions = [
  { label: 'IN PROGRESS', value: 'active' },
  { label: 'COMPLETED', value: 'completed' },
  { label: 'ALL', value: '' },
]

type ComponentData = {
  initialLoading: boolean
  reloading: boolean
  searchText: string
  filter: string
  filterOptions: Array<{ label: string; value: string }>
  selectedFilter: { label: string; value: string }
  selectedPeriod
  patientNoun: string
  showPatientManagementWizard: boolean
  chosenPatientForEditId: string | null
  patientManagementWizardActionContext: UserActionContexts.New | UserActionContexts.Edit
  showRemovePackageFromPatientDialog: boolean
  isSendingRemovePackageFromPatientRequest: boolean
  errorMessage: ''
  startTimestamp: number
  endTimestamp: number
  includeVitalsTable: boolean
  cashFlowIsToDate: boolean
}

export default Vue.extend({
  name: 'SiteStats',
  components: {
    SiteStatsCashFlowDataTable,
    SiteStatsLiveStatusDataTable,
    SiteStatsGlucometerDataTable,
    SiteStatsVitalsDataTable,
    SiteStatsFilterFunctions,
  },
  data(): ComponentData {
    return {
      errorMessage: '', // TODO ERROR MESSAGE
      initialLoading: true,
      reloading: false,
      searchText: '',
      filter: 'current',
      filterOptions,
      selectedFilter: filterOptions[0],
      startTimestamp: moment()
        .startOf('month')
        .valueOf(),
      endTimestamp: moment().valueOf(),
      selectedPeriod: null,
      patientNoun: PATIENT_NOUN,
      showPatientManagementWizard: false,
      chosenPatientForEditId: null,
      patientManagementWizardActionContext: UserActionContexts.New,
      showRemovePackageFromPatientDialog: false,
      isSendingRemovePackageFromPatientRequest: false,
      includeVitalsTable: INCLUDE_VITALS_PROGRAM,
      cashFlowIsToDate: false,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.app, {
      isAdminUser: AppGetterNames.isAdminUser,
      isExecUser: AppGetterNames.isExecUser,
      isCareTeamUser: AppGetterNames.isCareTeamUser,
      // isNursingHomeUser: AppGetterNames.isNursingHomeUser
    }),
    ...mapGetters({
      siteStats: `${ModuleNames.siteStats}/${SiteStatsGetterNames.siteStatses}`,
    }),
    ...mapGetters(ModuleNames.siteStats, [SiteStatsGetterNames.siteStatses]),

    hasRevenueData(): boolean {
      // 'config' contains the revenue stats...
      return this.activeRealSites.some(s => s?.siteUsageStats?.config != null)
    },

    activeSites(): FlatSite[] {
      return this[SiteStatsGetterNames.siteStatses].filter(
        site =>
          site &&
          (site.siteUsageStats?.sharedDeviceProgramActive ||
            // these will be null for roche consultants
            this.isProgramActive(
              site.siteUsageStats?.config?.glucometerStartDate,
              site.siteUsageStats?.config?.glucometerEndDate
            ) ||
            this.isProgramActive(
              site.siteUsageStats?.config?.vitalsStartDate,
              site.siteUsageStats?.config?.vitalsEndDate
            ))
      ) //.sort((a, b) => ((a.sandbox ? 'z' : 'a')  + a.org + a.siteName || '').localeCompare((b.sandbox ? 'z' : 'a') + b.org + b.siteName || ''))
    },
    activeRealSites(): FlatSite[] {
      return this.activeSites.filter(site => site.sandbox !== true)
    },

    filteredSites(): FlatSite[] {
      const lowerCasedSearchText = this.searchText.toLowerCase()
      let as = this.activeSites
      console.log('active sites:')
      console.log(as)
      return this.activeSites.filter(
        site => site && site.siteName && site.siteName.toLowerCase().includes(lowerCasedSearchText)
      )
    },
    numberOfActiveRealHomes(): number {
      return this.activeRealSites.length
    },
    numberOfModems(): number {
      return this.activeRealSites.reduce((prev, cur) => prev + (cur.siteUsageStats?.gateways || 0), 0)
    },
    stripRevenueNumeric(): number {
      return this.activeRealSites.reduce((prev, cur) => prev + (calcStripRevenue(cur.siteUsageStats) || 0), 0)
    },
    stripRevenue(): string {
      return toCurrency(this.stripRevenueNumeric)
    },
    oneTimeGatewayRevenueNumeric(): number {
      return this.activeRealSites.reduce(
        (prev, cur) => prev + (calcOneTimeVitalSignGatewayRevenue(cur.siteUsageStats) || 0),
        0
      )
    },
    oneTimeGatewayRevenue(): string {
      return toCurrency(this.oneTimeGatewayRevenueNumeric)
    },
    monthlyRevenueNumeric(): number {
      return this.activeRealSites.reduce((prev, cur) => prev + (calcMonthlyRevenueTotal(cur.siteUsageStats) || 0), 0)
    },
    monthlyRevenue(): string {
      return toCurrency(this.monthlyRevenueNumeric)
    },
    totalRevenue(): string {
      return toCurrency(this.oneTimeGatewayRevenueNumeric + this.monthlyRevenueNumeric + this.stripRevenueNumeric)
    },
    oneTimeCostNumeric(): number {
      return this.activeRealSites.reduce(
        // hacky but we don't know which gateways are for vitals or glucometer. It's fine if we keep these in separate pipelines and DDB tables.
        (prev, cur) =>
          prev +
          Math.max(
            getOneTimeGlucometerGatewayCost(cur.siteUsageStats) || 0,
            getOneTimeVitalsGatewayCost(cur.siteUsageStats) || 0
          ),
        0
      )
    },
    oneTimeCost(): string {
      return toCurrency(this.oneTimeCostNumeric)
    },
    monthlyCostNumeric(): number {
      return this.activeRealSites.reduce(
        // hacky solution for now. We don't know which GWs are for glucometer or vitals... so this will work so long as we keep vitals and glucometer on separate sites.
        (prev, cur) =>
          prev + Math.max(calcTotalEmrCost(cur.siteUsageStats) || 0, calcTotalEmrCost(cur.siteUsageStats) || 0),
        0
      )
    },
    monthlyCost(): string {
      return toCurrency(this.monthlyCostNumeric)
    },
    totalCost(): string {
      return toCurrency(this.oneTimeCostNumeric + this.monthlyCostNumeric)
    },
    totalProfitNumber(): number {
      // eslint-disable-next-line prettier/prettier
      return (
        this.oneTimeGatewayRevenueNumeric +
        this.monthlyRevenueNumeric +
        this.stripRevenueNumeric -
        (this.oneTimeCostNumeric + this.monthlyCostNumeric)
      )
    },
    totalProfit(): string {
      return toCurrency(this.totalProfitNumber)
    },
  },
  async mounted(): Promise<void> {
    await this[SiteStatsActionNames.getSiteStatses]({
      startTimestamp: this.startTimestamp,
      endTimestamp: this.endTimestamp,
    })
    this.initialLoading = false
  },

  methods: {
    MIN_TIMESTAMP() {
      return MIN_TIMESTAMP
    },
    ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    loadSiteStats(payload: { startTimestamp: number; endTimestamp: number }) {
      this.reloading = true
      this.startTimestamp = payload.startTimestamp
      this.endTimestamp = payload.endTimestamp
      const lastYearTimestamp = moment()
        .add(-1, 'y')
        .startOf('day')
        .valueOf()
      this[SiteStatsActionNames.getSiteStatses]({
        startTimestamp: Math.max(lastYearTimestamp, payload.startTimestamp - OFFSET_HOURS_TIMESTAMP),
        endTimestamp: payload.endTimestamp,
      }).then(() => (this.reloading = false))
    },
    isProgramActive(startTs: number | null, endTs: number | null): boolean {
      return startTs && (!endTs || moment(endTs).valueOf() > moment().valueOf())
    },
  },
})
